"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7212],{

/***/ 7212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Custom; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59848);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25935);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82723);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function Custom(props) {
    var html = props.html, css = props.css, fullWidth = props.fullWidth;
    var options = {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'name' does not exist on type 'DOMNode'.
        replace: function(param) {
            var name = param.name, attribs = param.attribs, children = param.children;
            if (name === "a") {
                // Return Internal Link
                if (attribs.href.startsWith("/")) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        href: attribs.href,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: attribs.class,
                            children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* .domToReact */ .du)(children, options)
                        })
                    });
                }
                // Return External Link
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, lodash_omit__WEBPACK_IMPORTED_MODULE_4___default()(attribs, "class"), {
                    className: attribs.class,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* .domToReact */ .du)(children, options)
                }));
            }
        }
    };
    var contentHTML = (0,html_react_parser__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(html, options);
    var contentCSS = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
        children: css
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            fullWidth ? contentHTML : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: contentHTML
            }),
            contentCSS
        ]
    });
};


/***/ })

}]);